export default __webpack_public_path__ + "static/media/reply-gray.250670c5.svg";